import { useMarkerStore } from "../../../../store/markerStore";
import useHomeStore from "../../../../store/homeStore";
import useAnalyticsStore from "../../../../store/analyticsStore";

export default function useStoreReset() {
  const setResetMarker = useMarkerStore(state => state.setResetMarker);
  const setShowResultCollapse = useHomeStore(state => state.setShowResultCollapse);
  const setPreviewAnalytics = useAnalyticsStore(state => state.setPreviewAnalytics);

  const clearStore = () => {
    setResetMarker();
    setShowResultCollapse(false);
    setPreviewAnalytics([]);
  };

  return { clearStore };
}
